<template>
    <v-container
            fluid
    >
        <v-row
                align="center"
                justify="center">
            <v-flex xs12>
                <v-img
                        class="ml-4 mr-4"
                        :src="language === 'es' ? require('../../assets/residencial_mx.png') : require('../../assets/residencial_eu.png')"
                        height="250px"
                        contain
                ></v-img>
            </v-flex>
            <div class="text-center">
                <br>
                <h2>{{$t('registro_exito')}}</h2>
                <h4>{{$t('msj_cerrar_pagina')}}</h4>
                <h4>{{$t('msj2_cerrar_pagina')}}</h4>
                <h4>{{$t('msj_cerrar_pagina_complemento')}}</h4>
                <br>
                <v-btn color="primary" to="/">
                    {{$t('inicio')}}
                </v-btn>
            </div>
        </v-row>
    </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'register_success',
  computed: {
    ...mapState(['language'])
  }
}
</script>

<style scoped>

</style>
